import './Sonar.scss';
import { AdminReferenceDebugger } from '@ui/AdminReferenceDebugger';
import { AppIndex } from './Index';
import { FollowerInitializer } from '@ui/FollowerInitializer';
import { GatewayContent } from '../gateway/general';
import { Layout } from 'antd';
import React from 'react';
import { Sidebar } from './sidebar';
import { useAction, useCurrentCustomer, useCurrentUser, useFeatureFlags, useNotifications, useOnMount, useOrganizations, useSonarSelector, useStakeholders, useUsers } from '@hooks';
export const Sonar = () => {
    var _a, _b;
    const loadNotifications = useAction(useNotifications.loadAction);
    useOnMount(() => {
        loadNotifications();
    });
    useFeatureFlags();
    useStakeholders();
    const isCurrentCustomerLoaded = Boolean(useCurrentCustomer().id);
    const isCurrentUserLoaded = Boolean(useCurrentUser().id);
    const areAllOrganizationsLoaded = Boolean((_a = useOrganizations()) === null || _a === void 0 ? void 0 : _a.length);
    const areAllUsersLoaded = Boolean((_b = useUsers()) === null || _b === void 0 ? void 0 : _b.length);
    const areFeaturesLoaded = Boolean(useSonarSelector(useFeatureFlags.selectors.data));
    const areNotificationsLoaded = Boolean(useSonarSelector(useNotifications.selectors.dataExists));
    const isReady = isCurrentCustomerLoaded &&
        areFeaturesLoaded &&
        areAllOrganizationsLoaded &&
        areAllUsersLoaded &&
        isCurrentUserLoaded &&
        areNotificationsLoaded;
    if (!isReady) {
        return React.createElement(GatewayContent, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(AdminReferenceDebugger, null),
        React.createElement(FollowerInitializer, null),
        React.createElement(Layout, { hasSider: true, id: 'sonar' },
            React.createElement(Sidebar, null),
            React.createElement(AppIndex, null))));
};
